import Isolated from "./isolated";
import ListItem from "./listItem";
import Regular from "./regular";
import SearchItem from "./searchItem";

const Post = {
  Isolated,
  Regular,
  SearchItem,
  ListItem,
};

export default Post;
